export const QA_NAME_EDIT_BUILDING_AND_CATEGORY_MODAL =
  'edit_building_and_category_modal'

export const PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_FIELD = 'mapping'

export const QA_NAME_PROVIDER_EDIT_BUILDING_AND_CATEGORY_DELETE_MAPPING_ROW_BTN =
  'deleteMappingRow'

export const PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_BUILDINGS_FIELD =
  'buildings'

export const PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_CATEGORIES_FIELD =
  'categories'

export const PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_UNIQUE_ID_FIELD =
  'rowId'

export const PROVIDER_EDIT_BUILDING_AND_CATEGORY_MAPPING_ROW_UNIQUE_ID_PREFIX =
  'mappingRow_'
